<app-header></app-header>
<div class="content-container">
  <app-menu></app-menu>
  <div class="router-content">
    <router-outlet></router-outlet>
  </div>
</div>
